module.exports = __webpack_public_path__ + "staticesp/media/marcas (1).a651e4f3.png";